VLW.BouteillePIXI = class extends VLW.classBase {
	constructor(resource, mask, parent, zIndex) {
		super();
		this.parent = parent;
		this.sprite = new PIXI.Sprite(resource.texture);
		this.mask   = new PIXI.Sprite(mask.texture);
		this.parent.addChild(this.sprite, this.mask);
		this.sprite.anchor.set(.5);
		this.mask.anchor.set(.5);
		this.sprite.mask = this.mask;
		this.sprite.position.set(this.sprite.width * .5, this.sprite.height * .5);
		this.mask.position.set(this.sprite.x, this.sprite.y);
		this.mask.xOr    = this.mask.position.x;
		this.mask.yOr    = this.mask.position.y;
		this.mask.zIndex = 0;
		this.mask.scale.set(0);
		this.zIndex = zIndex;
	}
	
	set zIndex(zIndex) {
		this.sprite.zIndex = zIndex;
	}
	
	outro() {
		TweenMax.killTweensOf(this.mask);
		TweenMax.killTweensOf(this.sprite);
		TweenMax.to(this.sprite, .75*2.5, {alpha: 0,pixi: {scale: .85}, ease: Power2.easeInOut, delay: 0});
		TweenMax.to(this.mask  , .75*2, {pixi: {scale: 2.5}, x: this.mask.xOr - 400, y: this.mask.yOr + 400, ease: Sine.easeOut});
	}
	
	intro(zIndex, isFirst) {
		let variationY = isFirst ? 0 : -400;
		let variationX = isFirst ? 0 : 200;
		let _delay     = (isFirst) ? 0 : .2;
		let _timeAlpha = (isFirst) ? -1.25 : -1;
		this.zIndex    = zIndex;
		TweenMax.killTweensOf(this.sprite);
		TweenMax.killTweensOf(this.mask);
		let tl = new TimelineMax({delay: _delay});
		tl.fromTo(this.sprite	, 2.00+_timeAlpha, {alpha: 0,pixi: {scale: 1}}, {alpha: 1,pixi: {scale: 1}, ease: Power2.easeInOut}, 0);
		tl.fromTo(this.mask		, 2.75+_timeAlpha, {pixi: {scale: 2}, x: this.mask.xOr + variationX, y: this.mask.yOr + variationY}, {pixi: {scale: 4}, ease: Sine.easeInOut, x: this.mask.xOr, y: this.mask.yOr}, 0);
	}
	
	instanceClean() {
		return;
		TweenMax.killTweensOf(this.sprite);
		TweenMax.killTweensOf(this.mask);
		this.parent.removeChild(this.sprite, this.mask);
		this.sprite	.destroy({children: true, texture: true, baseTexture: true});
		this.mask	.destroy({children: true, texture: true, baseTexture: true});
		super.instanceClean();
	}
	
	render() {
	}
}